'use es6';

import { createAction as createActionFromReduxActions } from 'redux-actions';
import { push } from 'FormsUI/actions/HistoryActions';
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import { PopUpFormTypes, NewEditorFormTypes } from 'FormsUI/constants/FormCreation';
import { HELPDESK } from 'FormsUI/constants/WorkspaceFlags';
import Logger from 'forms-utils-lib/logger/Logger';
import EmbedVersions from 'forms-utils-lib/constants/formDefinition/EmbedVersions';
import { FormErrors } from 'FormsUI/api/Forms';
import { NEW_EDITOR_ERROR_CATEGORIES } from 'FormsUI/api/NewEditorCreation';
import { getTemplatesRoute } from 'FormsUI/lib/RouteGenerators';
import { getUserId } from 'FormsUI/selectors/User';
import { shouldAddToSubmissionNotifications } from 'FormsUI/selectors/Scope';
import { getFormStyle } from 'FormsUI/selectors/FormDefinition';
import { getSelectedType } from 'FormsUI/selectors/FormCreation';
import { isUngatedForShareEmbedV3 } from 'FormsUI/selectors/Gates';
import Themes from 'FormsUI/lib/Themes';
import { getLangToFormsLang } from 'FormsUI/utils/Lang';
import { getFormFieldLabel } from 'FormsUI/utils/FormFieldsUtils';
import { ACCOUNT_BUSINESS_UNIT_ID } from 'FormsCommonComponents/constants/BusinessUnits';
import { getBusinessUnits } from 'FormsUI/selectors/BusinessUnits';
import getSubscriptionDefinitionsByBusinessUnitId from 'FormsUI/actions/LegalConsent/getSubscriptionDefinitionsByBusinessUnitId';
import { fetchSettingsIfNeeded } from 'forms-utils-lib/settings/actions';
import createNewFormFieldGroup from 'forms-utils-lib/formFieldGroup/utils/createFormFieldGroup';
import createFormField from 'forms-utils-lib/formField/utils/createFormField';
import { generateTimestampedName } from 'FormsUI/utils/FormCreationUtils';
import { FAIL_CREATING_FORM } from 'FormsUI/actions/formCreation/formCreationActions';
import createPopupForm from 'FormsUI/actions/formCreation/createPopupForm';
import { createNewEditorForm } from 'FormsUI/actions/formCreation/newEditor/createNewEditorForm';
export const RETRY_MAX_ATTEMPTS = 5;
export const selectBusinessUnit = createActionFromReduxActions('FormCreation/selectBusinessUnit');
export const selectFormType = createActionFromReduxActions('FormCreation/selectFormType');
export const failCreatingForm = (reason = FormErrors.UNKNOWN) => ({
  type: FAIL_CREATING_FORM,
  meta: {
    notification: {
      type: 'danger',
      title: I18n.text('formCreation.errorHeading'),
      message: I18n.text(`formCreation.errorMessages.${reason}`)
    }
  }
});
export const failCreatingNewEditorForm = (reason = NEW_EDITOR_ERROR_CATEGORIES.UNKNOWN) => ({
  type: FAIL_CREATING_FORM,
  meta: {
    notification: {
      type: 'danger',
      title: I18n.text('formCreation.errorHeading'),
      message: I18n.text(`formCreation.errorMessages.${reason}`)
    }
  }
});

// TODO: move to lib?
export function buildForm(getState, attemptNumber = 1) {
  const state = getState();
  const name = generateTimestampedName(attemptNumber);
  const lang = getLangToFormsLang(getLang());
  const selectedType = getSelectedType(state);
  const metaData = [{
    name: 'lang',
    value: lang
  }];
  const embedVersion = isUngatedForShareEmbedV3(state) && EmbedVersions.V3;
  if (selectedType) {
    metaData.push({
      name: 'embedType',
      value: selectedType
    });
  }
  const notifyRecipients = shouldAddToSubmissionNotifications(getState()) ? getUserId(getState()) : '';
  return Object.assign({
    formFieldGroups: [createNewFormFieldGroup({
      field: createFormField({
        name: 'email',
        label: getFormFieldLabel('Email'),
        required: true,
        groupName: 'contactinformation'
      })
    })]
  }, embedVersion ? {
    embedVersion
  } : {}, {
    cssClass: 'hs-form stacked',
    method: 'POST',
    style: JSON.stringify(getFormStyle(getState(), true)),
    submitText: I18n.text('defaultForm.submitLabel'),
    inlineMessage: I18n.text('defaultForm.thankYouMessage'),
    redirect: '',
    themeName: Themes.getDefaultTheme(),
    name,
    metaData,
    notifyRecipients
  });
}

// TODO: extract to its own file
export const getIsCurrentInboxHelpdesk = (inboxes, inboxId) => {
  const helpdeskInbox = inboxes.find(inbox => inbox.workspaceFlag === HELPDESK);
  return helpdeskInbox ? helpdeskInbox.id === inboxId : false;
};
export const createFormFromType = () => (dispatch, getState) => {
  const selectedType = getSelectedType(getState());
  if (Object.prototype.hasOwnProperty.call(PopUpFormTypes, selectedType)) {
    Promise.all([dispatch(fetchSettingsIfNeeded()), dispatch(getSubscriptionDefinitionsByBusinessUnitId())]).then(() => {
      dispatch(createPopupForm(1, {
        type: selectedType
      }));
    }).catch(error => {
      Logger.error(`Failed create form type: ${selectedType}`, error);
    });
    return;
  }
  if (Object.prototype.hasOwnProperty.call(NewEditorFormTypes, selectedType)) {
    dispatch(createNewEditorForm());
    return;
  }
  dispatch(push(getTemplatesRoute(selectedType)));
};
export const preSelectFormBusinessUnit = () => (dispatch, getState) => {
  const state = getState();
  const businessUnits = getBusinessUnits(state);
  const hasOneBusinessUnit = businessUnits.length === 1;
  if (hasOneBusinessUnit) {
    dispatch(selectBusinessUnit(businessUnits[0].id));
  } else {
    dispatch(selectBusinessUnit(ACCOUNT_BUSINESS_UNIT_ID));
  }
  return;
};